import React from 'react';
import { cx } from '../cx';

// D-09 §15.2 — Textarea (.field > label + .textarea + .help)
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  /** 성공 안내 — Input 과 같은 규칙(error 와 상호배타, error 우선) */
  success?: string;
  /** 부모 flex 컨테이너를 세로로 가득 채우는 변형(.field-fill) — 풀높이 작성 화면용 */
  fill?: boolean;
  /** 내부 <textarea> 요소에 부착할 클래스 — className 은 래퍼(.field)에 부착(하위호환) */
  textareaClassName?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, error, success, fill = false, textareaClassName = '', className = '', id, ...props },
  ref,
) {
  return (
    <div className={cx('field', fill && 'field-fill', error ? 'error' : success ? 'success' : '', className)}>
      {label && <label htmlFor={id}>{label}</label>}
      <textarea
        id={id}
        ref={ref}
        className={cx('textarea', textareaClassName)}
        {...props}
      />
      {(error || success) && <span className="help">{error || success}</span>}
    </div>
  );
});
